const urls: Readonly<{
	readonly incomingCall: {
		readonly detail: {
			readonly url: (incomingCallId?: string) => string;
		};
		readonly url: () => '/v1/incoming-call';
	};
}> = Object.freeze({
	incomingCall: {
		url: (): '/v1/incoming-call' => `/v1/incoming-call`,
		detail: {
			url: (incomingCallId: string = ':incomingCallId'): string =>
				`${urls.incomingCall.url()}/${incomingCallId}`,
		},
	},
} as const);

export { urls };
